export const CATEGORY_ORDER = ["Environment", "Social", "Governance"];

export const buildDisclosureMap = (disclosures = []) => {
  const map = new Map();
  disclosures.forEach((disclosure) => {
    if (!map.has(disclosure.code)) {
      map.set(disclosure.code, disclosure);
    }
  });
  return map;
};

export const buildDisclosuresByPillar = (
  selectedCodesByCategory = {},
  disclosureMap,
) => {
  const result = {};
  CATEGORY_ORDER.forEach((pillar) => {
    const codes = selectedCodesByCategory[pillar] || [];
    result[pillar] = codes.map((code) => {
      const disclosure = disclosureMap.get(code) || {};
      return {
        code,
        title: disclosure.title || disclosure.name || code,
      };
    });
  });
  return result;
};

export const buildPillarCounts = (
  selectedCodesByCategory = {},
  isDisclosureCompleted,
) => {
  const counts = {};
  CATEGORY_ORDER.forEach((pillar) => {
    const codes = selectedCodesByCategory[pillar] || [];
    const completed = codes.filter((code) =>
      isDisclosureCompleted?.(code),
    ).length;
    const total = codes.length;
    const percentage = total ? Math.round((completed / total) * 100) : 0;
    counts[pillar] = { total, completed, percentage };
  });
  return counts;
};

export const getDisclosureValue = (
  entries = [],
  labels = { entries: "entries", items: "items" },
) => {
  if (!entries || entries.length === 0) {
    return { value: "—", unit: "" };
  }

  if (entries.length > 1) {
    const numericValues = entries
      .map((entry) => Number(entry.value))
      .filter((value) => Number.isFinite(value));
    if (numericValues.length === entries.length && numericValues.length > 0) {
      const sum = numericValues.reduce((a, b) => a + b, 0);
      const unit = entries[0]?.valueUnit || entries[0]?.unit || "";
      return { value: sum.toLocaleString(), unit };
    }
    return { value: `${entries.length} ${labels.entries}`, unit: "" };
  }

  const entry = entries[0] || {};
  if (Array.isArray(entry.subEntries) && entry.subEntries.length > 0) {
    return { value: `${entry.subEntries.length} ${labels.items}`, unit: "" };
  }
  return {
    value: entry.value || "—",
    unit: entry.valueUnit || entry.unit || "",
  };
};
